import { motion } from 'framer-motion';
import PageLayout from '@/components/layout/PageLayout';

const ImprintPage = () => {
  return (
    <PageLayout>
      <section className="pb-24 pt-8" data-testid="imprint-page">
        <div className="max-w-3xl mx-auto px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold text-taxera-charcoal mb-12">
              Imprint
            </h1>

            <div className="space-y-10">
              <section>
                <h2 className="font-heading text-xl font-bold text-taxera-charcoal mb-4">Company Information</h2>
                <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200">
                  <dl className="space-y-4">
                    <div>
                      <dt className="text-sm font-medium text-slate-500">Company Name</dt>
                      <dd className="text-taxera-charcoal font-medium">Taxera Technologies GmbH</dd>
                    </div>
                    <div>
                      <dt className="text-sm font-medium text-slate-500">Legal Form</dt>
                      <dd className="text-taxera-charcoal">Gesellschaft mit beschrankter Haftung (GmbH)</dd>
                    </div>
                    <div>
                      <dt className="text-sm font-medium text-slate-500">Registered Address</dt>
                      <dd className="text-taxera-charcoal">Sihleggstrasse 23, 8832 Wollerau, Switzerland</dd>
                    </div>
                    <div>
                      <dt className="text-sm font-medium text-slate-500">Commercial Register</dt>
                      <dd className="text-taxera-charcoal">CH-130.4.025.864-1 (Canton of Schwyz)</dd>
                    </div>
                    <div>
                      <dt className="text-sm font-medium text-slate-500">UID Number</dt>
                      <dd className="text-taxera-charcoal">CHE-248.949.004</dd>
                    </div>
                    <div>
                      <dt className="text-sm font-medium text-slate-500">VAT Number</dt>
                      <dd className="text-taxera-charcoal">CHE-248.949.004 MWST</dd>
                    </div>
                  </dl>
                </div>
              </section>

              <section>
                <h2 className="font-heading text-xl font-bold text-taxera-charcoal mb-4">Management</h2>
                <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200">
                  <dl className="space-y-4">
                    <div>
                      <dt className="text-sm font-medium text-slate-500">Managing Director</dt>
                      <dd className="text-taxera-charcoal">Paul Antunes</dd>
                    </div>
                    <div>
                      <dt className="text-sm font-medium text-slate-500">Authorized Signatory</dt>
                      <dd className="text-taxera-charcoal">Paul Antunes (individual signature authority)</dd>
                    </div>
                  </dl>
                </div>
              </section>

              <section>
                <h2 className="font-heading text-xl font-bold text-taxera-charcoal mb-4">Contact</h2>
                <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200">
                  <dl className="space-y-4">
                    <div>
                      <dt className="text-sm font-medium text-slate-500">General Inquiries</dt>
                      <dd>
                        <a href="mailto:office@taxera.tech" className="text-taxera-blue hover:underline">office@taxera.tech</a>
                      </dd>
                    </div>
                    <div>
                      <dt className="text-sm font-medium text-slate-500">Data Protection</dt>
                      <dd>
                        <a href="mailto:privacy@taxera.tech" className="text-taxera-blue hover:underline">privacy@taxera.tech</a>
                      </dd>
                    </div>
                    <div>
                      <dt className="text-sm font-medium text-slate-500">Legal</dt>
                      <dd>
                        <a href="mailto:legal@taxera.tech" className="text-taxera-blue hover:underline">legal@taxera.tech</a>
                      </dd>
                    </div>
                  </dl>
                </div>
              </section>

              <section>
                <h2 className="font-heading text-xl font-bold text-taxera-charcoal mb-4">Liability Disclaimer</h2>
                <p className="text-slate-600 leading-relaxed">
                  The content of this website has been prepared with the greatest possible care. However, Taxera Technologies GmbH does not guarantee the accuracy, completeness, or timeliness of the content provided. Use of the website's content is at the user's own risk. Contributions identified by name reflect the opinions of the respective authors and not necessarily the opinion of Taxera Technologies GmbH.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-xl font-bold text-taxera-charcoal mb-4">Copyright</h2>
                <p className="text-slate-600 leading-relaxed">
                  The content and works on this website created by Taxera Technologies GmbH are subject to Swiss copyright law. Any duplication, processing, distribution, or any form of commercialization beyond the scope of copyright law requires the prior written consent of the respective author or creator.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </PageLayout>
  );
};

export default ImprintPage;
